
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import OverwriteGeneralMapOption from './OverwriteGeneralMapOption.vue';
import WarningMapOverwrite from './WarningMapOverwrite.vue';
import { InjectionKey } from '../../../core/injection-keys';
import { TenantConfig } from '../../../tenants/types';

/**
 * Destino de los polígonos que se cargan desde un modal (archivo, lotes pre-cargados, coordenadas):
 * - `pages.item.mergeLoadedPolygons = true`: checkbox "Sobreescribir mapa general" (por defecto se suman);
 * - `false`: solo el aviso de sobrescritura (siempre se reemplaza el mapa).
 * El reemplazo/suma efectivo lo decide `ItemMap.setNewPolygonInMap` con el mismo flag.
 */
@Component({
  components: {
    OverwriteGeneralMapOption,
    WarningMapOverwrite,
  },
})
export default class LoadedPolygonsTargetOption extends Vue {
  @Inject(InjectionKey.Tenant) readonly tenant!: TenantConfig;
  /** `true` = sobrescribir el mapa general (solo aplica si se suman). */
  @Prop({ default: false }) value!: boolean;

  get mergeLoadedPolygons(): boolean {
    return !!(this.tenant.pages.item && this.tenant.pages.item.mergeLoadedPolygons);
  }
}
